function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo, useEffect, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import history from 'helpers/history';
import { useAction } from 'hooks';
import Button from 'components/Form/Button';
import Modal from 'components/Modal';
import App from 'modules/App';
const UnsavedChangesModal = ()=>{
    const isNavigationBlocked = useSelector(App.selectors.isNavigationBlocked);
    const openModalId = useSelector(App.selectors.modal);
    const openModal = useAction(App.actions.openModal, App.constants.UNSAVED_CHANGES_MODAL);
    const onCloseModal = useAction(App.actions.closeModal);
    const unblock = useRef();
    useEffect(()=>{
        if (isNavigationBlocked) {
            unblock.current = history.block(()=>{
                openModal();
                return false;
            });
        } else if (unblock.current) {
            unblock.current();
            unblock.current = undefined;
        }
    }, [
        isNavigationBlocked
    ]);
    return /*#__PURE__*/ _jsxs(Modal, {
        modalId: App.constants.UNSAVED_CHANGES_MODAL,
        openModalId: openModalId,
        headerMessage: App.messages.headers.unsavedConfiguration,
        styleModifier: "md",
        onClose: onCloseModal,
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "text--paragraph mt-8 mb-8 pr-6",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, App.messages.infos.unsavedConfiguration))
            }),
            /*#__PURE__*/ _jsx(Button, {
                labelMessage: App.messages.buttons.ok,
                className: "btn--block btn--primary btn--filled",
                type: "button",
                onClick: onCloseModal
            })
        ]
    });
};
export default /*#__PURE__*/ memo(UnsavedChangesModal);
